import { render, staticRenderFns } from "./OfferCardNew.vue?vue&type=template&id=80af450e&"
import script from "./OfferCardNew.vue?vue&type=script&lang=js&"
export * from "./OfferCardNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports